
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { get, post } from "./common/http";
import { API_ENDPOINTS } from "./Utils/endpoints";


export const GetUserDetailById = (params: any) =>
  GET_ENC(API_ENDPOINTS.USER.GET_DETAIL_BY_ID + params, null);

export const GetUserDetail = (params: any) =>
  GET_ENC(API_ENDPOINTS.USER.GET_DETAIL + params, null);

export const GetUserList = (params: any) =>
  GET_ENC(API_ENDPOINTS.USER.GET_LIST + params, null);

export const CreateUser = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER.CREATE, data);

export const GetSaveUserFirmBranchSelection = (params: any) =>
  GET_ENC(API_ENDPOINTS.USER.GET_SAVE_USER_FIRM_BRANCH_SELECTION + params, null);

export const DeleteUser = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER.DELETE, data);

export const UpdateUser = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER.UPDATE, data);

export const ChangePassword = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER.CHANGE_PASSWORD, data);

export const SendInvite = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER.SEND_INVITE, data);

export const ReInvite = (data :any) =>{
  POST_ENC(API_ENDPOINTS.USER.REINVITE,data);
}

export const UpdateDefaultInvoice = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER.UPDATE_DEFAULT_INVOICE, data);

export const UpdateDefaultLR = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER.UPDATE_DEFAULT_LR, data);

export const GetUserRoleList = (params: any) =>
  GET_ENC(API_ENDPOINTS.USER.GET_USER_ROLE_LIST + params, null);

export const UpdateDefaultVoucher = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER.UPDATE_DEFAULT_VOUCHER, data);
